// import { mobileAppRoot } from 'app/config';
// import { Plugins } from '@capacitor/core';
// const { CustomNativePlugin } = Plugins;

// const Capacitor = window.Capacitor;

// // Device Status Exports
// export const isMobile = Capacitor && Capacitor.isNative && window.location.host === 'localhost';
// export const isIOS = isMobile && Capacitor.isIOS;
// export const isAndroid = isMobile && Capacitor.isAndroid;

// // Initialization
// let Network;
// let App;
// let Browser;
// let Device;
// let Share;

// export let isIpad = false;
// export let isIphone = false;

// if (isMobile) {
//   if (Capacitor.isPluginAvailable('Network')) {
//     Network = Capacitor.Plugins.Network;
//   }

//   if (Capacitor.isPluginAvailable('App')) {
//     App = Capacitor.Plugins.App;
//   }

//   if (Capacitor.isPluginAvailable('Browser')) {
//     Browser = Capacitor.Plugins.Browser;
//   }

//   if (Capacitor.isPluginAvailable('Share')) {
//     Share = Capacitor.Plugins.Share;
//   }

//   if (Capacitor.isPluginAvailable('Device')) {
//     Device = Capacitor.Plugins.Device;

//     // Assign device info upon init
//     Device.getInfo().then(deviceInfo => {
//       isIpad = isIOS && deviceInfo.model === 'iPad';
//       isIphone = isIOS && deviceInfo.model === 'iPhone';
//     });
//   }
// }

// // Network
// let networkHandler;
// export const assignNetworkChangeHandler = (onNetworkChange) => {
//   if (Network) {
//     networkHandler = Network.addListener('networkStatusChange', onNetworkChange);
//   }
// };

// export const handleCurrentNetworkStatus = (onNetworkStatus) => {
//   if (Network) {
//     Network.getStatus().then(onNetworkStatus);
//   }
// };

// export const removeNetworkChangeHandler = () => {
//   if (networkHandler) {
//     networkHandler.remove();
//   }
// };

// // Browser
// export const openRouteInApp = (url) => {
//   if (Browser) {
//     Browser.open({ url });
//   } else {
//     window.open(url);
//   }
// };

// // Browser
// export const closeRouteInApp = () => {
//   if (Browser) {
//     Browser.close();
//   }
// };

// // App
// export const openMobileRoute = (url) => {
//   if (App) {
//     App.openUrl({ url: `${mobileAppRoot}${url}` });
//   }
// };

// let backButtonHandler;
// export const addBackButtonListener = (handleBackButton) => {
//   if (App) {
//     removeBackButtonListener();
//     backButtonHandler = App.addListener('backButton', handleBackButton);
//   }
// };

// export const removeBackButtonListener = () => {
//   if (backButtonHandler) {
//     backButtonHandler.remove();
//   }
// };

// export const exitMobileApp = () => {
//   if (App && isAndroid) {
//     App.exitApp();
//   }
// };

// // Share
// export const canShare = !!(Share);
// export const share = (title, text, url, dialogTitle) => {
//   if (Share) {
//     return Share.share({
//       title,
//       text,
//       url,
//       dialogTitle
//     });
//   } else {
//     return Promise.reject();
//   }
// };


// export const isGooglefitEnabled = async(validicUserId) => {
//   // Checking Google Fit Connected
//   try{
//     if(CustomNativePlugin && isAndroid && validicUserId)
//     {
//       const { value } = await CustomNativePlugin.isGooglefitEnabled({ value: validicUserId });
//       return value;
//     }
//   }
//   catch(error){
//     return false;
//   }
//   return false;
// };


// export const disconnectGooglefit = async() => {
//   // Checking Google Fit Connected
//   try{
//     if(CustomNativePlugin && isAndroid)
//     {
//       const { value } = await CustomNativePlugin.disconnectGooglefit({ value: 'disconnectGoogleFit' });
//       return value;
//     }
//   }
//   catch(error){
//     return false;
//   }
//   return false;
// };


import { mobileAppRoot } from 'app/config';

import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';
import { Browser } from '@capacitor/browser';
import { Device } from '@capacitor/device';
import { Network } from '@capacitor/network';
import { Share } from '@capacitor/share';
import { registerPlugin } from '@capacitor/core';

// Your custom native plugin
const CustomNativePlugin = registerPlugin('CustomNativePlugin');

// Platform detection
export const isMobile = Capacitor.isNativePlatform();
export const isAndroid = isMobile && Capacitor.getPlatform() === 'android';
export const isIOS = isMobile && Capacitor.getPlatform() === 'ios';

// Device info
export let isIpad = false;
export let isIphone = false;

console.log('Platform:', Capacitor.getPlatform());

if (isMobile) {
  Device.getInfo().then(info => {
    const platform = Capacitor.getPlatform();
    isIpad = platform === 'ios' && info.model === 'iPad';
    isIphone = platform === 'ios' && info.model === 'iPhone';
  });
}

// --- Network ---
let networkListener;
export const assignNetworkChangeHandler = (callback) => {
  Network.addListener('networkStatusChange', callback)
    .then(listener => {
      networkListener = listener;
    })
    .catch(() => { });
};

export const handleCurrentNetworkStatus = (callback) => {
  Network.getStatus().then(callback).catch(() => { });
};

export const removeNetworkChangeHandler = () => {
  if (networkListener) {
    networkListener.remove();
    networkListener = undefined;
  }
};

export const openRouteInApp = async (url) => {
  try {
    if (Capacitor.getPlatform() === 'ios') {
      await App.openUrl({ url });
    } else if (Capacitor.getPlatform() === 'android') {
      await Browser.open({ url });
    } else if (Browser) {
      await Browser.open({ url });
    } else {
      window.location.href = url;
    }
  } catch (error) {
    console.warn('Redirect failed, falling back:', error);
    window.location.href = url;
  }
};


// // // --- Browser ---
// export const openRouteInApp = async (url) => {
//   try {
//     if (isMobile) {
//       await Browser.open({ url });
//     } else {
//       alert(url);
//       window.open(url, '_blank');
//     }
//   } catch (error) {
//     console.warn('Browser.open failed, fallback:', error);
//     window.location.href = url;
//   }
// };




// export const openRouteInApp = async (url) => {
//   try {
//     if (isIOS && Capacitor.isPluginAvailable('App')) {
//       await App.openUrl({ url });
//     } else if (isMobile) {
//       await Browser.open({ url });
//     } else {
//       window.location.href = url;
//     }
//   } catch (error) {
//     console.warn('Redirect failed, falling back:', error);
//     window.location.href = url;
//   }
// };


export const closeRouteInApp = () => {
  Browser.close().catch(() => { });
};

export const openMobileRoute = async (url) => {
  const fullUrl = `${mobileAppRoot}${url}`;

  const canUseAppPlugin =
    isMobile &&
    typeof App?.openUrl === 'function' &&
    Capacitor.isPluginAvailable('App');

  if (canUseAppPlugin) {
    try {
      await App.openUrl({ url: fullUrl });
    } catch (error) {
      console.warn('App.openUrl failed:', error);
      window.location.href = fullUrl;
    }
  } else {
    window.location.href = fullUrl;
  }
};

let backButtonListener;
// export const addBackButtonListener = (callback) => {
//   removeBackButtonListener();
//   App.addListener('backButton', callback)
//     .then(listener => {
//       backButtonListener = listener;
//     })
//     .catch(() => { });
// };

export const addBackButtonListener = (handleBackButton) => {
  removeBackButtonListener();

  App.addListener('backButton', (event) => {
    event.preventDefault?.();

    if (typeof handleBackButton === 'function') {
      handleBackButton(event);
    }
  })
    .then(listener => {
      backButtonListener = listener;
    })
    .catch((err) => {
      console.log('Failed to register back button listener:', err);
    });
};

export const removeBackButtonListener = () => {
  if (backButtonListener) {
    backButtonListener.remove();
    backButtonListener = undefined;
  }
};

export const exitMobileApp = () => {
  if (isAndroid) {
    App.exitApp().catch(() => { });
  }
};

export const canShare = async () => {
  return isMobile;
};

export const share = async (title, text, url, dialogTitle) => {
  const available = await canShare();
  if (!available) {
    return Promise.reject(new Error('Sharing not available'));
  }

  return Share.share({ title, text, url, dialogTitle });
};

// --- Custom Plugin: Google Fit ---
export const isGooglefitEnabled = async (validicUserId) => {
  try {
    if (CustomNativePlugin && isAndroid && validicUserId) {
      const { value } = await CustomNativePlugin.isGooglefitEnabled({ value: validicUserId });
      return value;
    }
  } catch (error) {
    return false;
  }
  return false;
};

export const disconnectGooglefit = async () => {
  try {
    if (CustomNativePlugin && isAndroid) {
      const { value } = await CustomNativePlugin.disconnectGooglefit({ value: 'disconnectGoogleFit' });
      return value;
    }
  } catch (error) {
    return false;
  }
  return false;
};
